interface TabsProps {
  tabs: { id: string; label: string; icon?: string; count?: number }[];
  active: string;
  onChange: (id: string) => void;
  className?: string;
}

export default function Tabs({ tabs, active, onChange, className = "" }: TabsProps) {
  return (
    <div
      role="tablist"
      className={`inline-flex max-w-full items-center gap-1 overflow-x-auto overscroll-x-contain rounded-full border border-background-200 bg-background-200/60 p-1 [scrollbar-width:none] ${className}`}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            role="tab"
            type="button"
            aria-selected={isActive}
            className={`press inline-flex min-h-[2.5rem] shrink-0 items-center gap-2 whitespace-nowrap rounded-full px-3.5 text-sm font-medium cursor-pointer sm:min-h-[2rem] ${
              isActive
                ? "bg-background-50 text-foreground-950 shadow-card"
                : "text-foreground-600 hover:text-foreground-900"
            }`}
          >
            {tab.icon && (
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className={`${tab.icon} text-[13px] leading-none`}></i>
              </span>
            )}
            {tab.label}
            {typeof tab.count === "number" && (
              <span
                className={`rounded-full px-1.5 py-0.5 text-xs tabular-nums ${
                  isActive ? "bg-primary-100 text-primary-800" : "bg-background-200 text-foreground-600"
                }`}
              >
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}